<template>
	<layout-page title="Market">
		<!-- header -->
		<div
			class="bg-green px-4 md:px-6 py-4 md:rounded-tl-2xl lg:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center"
		>
			<h1 class="text-2xl md:text-4xl font-semibold text-white">
				{{ __("Market News") }}
			</h1>
		</div>

		<div
			class="flex-grow lg:overflow-hidden bg-gray-100 lg:grid lg:grid-cols-2 lg:gap-x-6"
		>
			<!-- ZMP column -->
			<div class="pt-4 pr-4 pl-4 lg:pr-0 lg:pl-6 flex flex-col">
				<div class="space-y-4">
					<h2 class="text-2xl font-semibold text-gray-900">Futures</h2>
					<iframe
						class="flex-grow rounded-b-xl; overflow-y-auto; min-h-[655px]"
						v-bind:src="zmpIframeUrl"
						style="border: none; width: 100%"
					></iframe>
				</div>

				<div class="my-4">
					<h2 class="text-2xl font-semibold text-gray-900 mb-4">Markt</h2>
					<div class="flex">
						<button
							class="rounded-tl-lg py-2 px-4 text-white font-semibold"
							:class="tabActive == 'grain' ? 'bg-gray-700' : 'bg-gray-500'"
							v-on:click="tabActive = 'grain'"
						>
							{{ __("Grain") }}
						</button>
						<button
							class="rounded-tr-lg py-2 px-4 text-white font-semibold"
							:class="tabActive == 'oilseeds' ? 'bg-gray-700' : 'bg-gray-500'"
							v-on:click="tabActive = 'oilseeds'"
						>
							{{ __("Oilseeds") }}
						</button>
					</div>
					<div class="rounded-tr-lg bg-white md:grid md:grid-cols-2">
						<div class="pb-4">
							<div
								class="bg-gray-700 py-1.5 px-4 text-white font-semibold text-xl rounded-tr-xl md:rounded-tr-none"
							>
								{{ __("Bull") }}
							</div>

							<img
								style="width: 100%"
								src="data:image/svg+xml;base64,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"
								class="max-w-[7rem] m-6"
							/>

							<div
								v-for="(item, idx) in zmpNewsFeed[tabActive].bullish_factors"
								:key="idx"
								class="mx-4 my-2 flex gap-x-2 text-lg items-start leading-6"
							>
								<ui-icon
									name="arrow-up-right"
									stroke-width="2"
									class="mt-1 flex-shrink-0 flex-grow-0 text-green-500 w-5 h-5"
								/>
								{{ item }}
							</div>
						</div>
						<div class="pb-4">
							<div
								class="bg-gray-700 py-1.5 px-4 text-white font-semibold text-xl md:rounded-tr-xl"
							>
								{{ __("Bear") }}
							</div>

							<img
								src="data:image/svg+xml;utf8;base64,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"
								style="width: 100%"
								class="max-w-[7rem] m-6"
							/>

							<div
								v-for="(item, idx) in zmpNewsFeed[tabActive].bearish_factors"
								:key="idx"
								class="hyphens mx-4 my-2 flex gap-x-2 text-lg items-start leading-6"
							>
								<ui-icon
									name="arrow-down-right"
									stroke-width="2"
									class="mt-1 flex-shrink-0 flex-grow-0 text-red-600 w-5 h-5"
								/>
								{{ item }}
							</div>
						</div>
					</div>
					<div class="bg-white p-4 rounded-b-xl">
						<ui-icon
							class="h-5 w-5 inline text-orange-500"
							name="fa-arrow-right"
							stroke-width="2.5"
							v-if="!showNewsFeed"
						/>
						<a
							href="#"
							v-if="!showNewsFeed"
							class="text-orange-500 underline ml-2"
							@click.prevent="showNewsFeed = !showNewsFeed"
							>{{ __("weiterlesen") }}</a
						>
						<span
							v-if="showNewsFeed"
							v-html="zmpNewsFeed[tabActive].description"
						></span>
					</div>
				</div>
			</div>

			<!-- bull and bear column -->
			<div
				class="space-y-4 overflow-y-auto pt-4 pr-4 pl-4 pb-6 lg:pl-0 lg:pr-6"
			>
				<h2 class="text-2xl font-semibold text-gray-900" id="marktkompass">
					{{ __("cropspot Market Compass") }}
				</h2>

				<div v-if="marketNewsCurrent">
					<div
						class="bg-gray-700 rounded-t-lg py-2 px-4 text-white font-semibold"
					>
						{{ marketNewsCurrent.title }}
						<ui-dropdown
							class="flex-grow min-w-0"
							button-class="pl-3 pr-2 py-1.5 w-full min-w-0 flex items-center justify-between relative
                                        font-medium text-gray-100 bg-gray-500 hover:bg-gray-400 rounded-lg
                                        active:bg-gray-400 focus:gray-400 focus:ring-2 ring-gray-500 mt-1"
						>
							<template v-slot:button>
								<div class="flex-shrink flex-grow min-w-0 truncate text-left">
									{{ marketNewsCurrent.formattedDateString }}
								</div>
								<ui-icon
									class="ml-2 flex-shrink-0 h-5 w-5"
									name="chevron-down"
									stroke-width="2"
								/>
							</template>
							<template v-slot:items class>
								<button
									class="block w-full whitespace-nowrap text-left px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-orange-500 focus:text-white"
									type="button"
									v-for="option in marketNewsOptions"
									:key="option.id"
									v-on:click="changeIssue(option.id)"
								>
									{{ __(option.name) }}
								</button>
							</template>
						</ui-dropdown>
					</div>
					<div class="bg-white p-4 rounded-b-xl">
						<h3 class="text-lg font-semibold text-gray-900">
							{{ __("KURZ GESAGT...") }}
						</h3>
						<span v-html="marketNewsCurrent.formattedShortText"></span>

						<content-compass-item
							v-for="newsItem in marketNewsCurrent.items"
							:newsItem="newsItem"
							:key="newsItem.id"
						/>
					</div>
				</div>
			</div>
		</div>

		<!-- <iframe width="100%" height="6100" :src="hubspotIframeUrl" frameborder="0"></iframe> -->
	</layout-page>
</template>

<script>
export default {
	props: {
		zmpIframeUrl: {
			type: String,
			required: true,
		},
		zmpNewsFeed: {
			type: Object,
			required: true,
		},
		tabActive: {
			type: String,
			default: "grain",
		},
		marketNewsCurrent: {
			type: Object,
			required: false,
		},
		marketNewsArray: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			acl: this.$inertia.page.props.acl,
			hubspotIframeUrl: "https://7079844.hs-sites.com/kompass",
			marketNewsOptions: this.marketNewsArray.map((marketNews) => {
				return {
					id: this.__(marketNews.id),
					name: this.__(marketNews.formattedDateString),
				};
			}),
			showNewsFeed: false,
		};
	},
	mounted() {
		if(this.isDenied()){
			this.$bus.$emit('modal:open', {
				view: {
					view: 'views/Modal/PremiumRequired',
					data: {
						closeable: false
					},
				},
				blur: true,
				closeable: false,
			});
		}
	},
	methods: {
		isDenied() {
			return ! this.acl['market_news.read']
		},
		changeIssue(option_id) {
			this.$inertia.visit(
				this.$route("content.compass", { news_id: option_id })
			);
		},
	},
};
</script>

<style scoped>
.hyphens {
	-webkit-hyphens: auto;
	-ms-hyphens: auto;
	hyphens: auto;
}
</style>
